import { Form, useFormikContext } from 'formik';

import { Button } from '../../../../cdl/Button/Button';
import { DrawerContentLayout } from '../../../../cdl/Drawer/DrawerContentLayout';
import { FormikCustomerCompanySelect } from '../../../../common/form-elements/formik/FormikCustomerCompanySelect';
import { FormikDebug } from '../../../../common/form-elements/formik/FormikDebug';
import { FormikEnumOptionSelect } from '../../../../common/form-elements/formik/FormikEnumOptionSelect';
import { translate } from '../../../../common/helpers/translate.helper';
import { FormikMoneyInput } from '../../../../common/MoneyInput/FormikMoneyInput';

export const FormikCreateSurchargeForm = () => {
    const { isSubmitting, dirty } = useFormikContext();
    return (
        <Form style={{ height: '100%', minHeight: 0 }}>
            <DrawerContentLayout
                isBusy={isSubmitting}
                hasUnsavedChanges={dirty}
                primaryAction={
                    <Button type="submit" emphasis="high" isLoading={isSubmitting}>
                        {translate('surcharges.createbtn')}
                    </Button>
                }
            >
                <FormikEnumOptionSelect
                    name="packType"
                    enumType="packType"
                    label={translate('surcharges.formLabels.packtype')}
                />
                <FormikEnumOptionSelect
                    name="productGroup"
                    enumType="productGroup"
                    label={translate('surcharges.formLabels.productGroup')}
                    markAsOptional
                />
                <FormikCustomerCompanySelect
                    name="customerId"
                    label={translate('surcharges.formLabels.customer')}
                    markAsOptional
                />
                <FormikMoneyInput name="value" decimals={4} label={translate('surcharges.formLabels.value')} />

                <FormikDebug />
            </DrawerContentLayout>
        </Form>
    );
};
